import { Dispatch }                                                 from "redux";
import { endLoadingAction, startLoadingAction, toggleSpMenuAction } from "./GlobalAction";

class GlobalDispatcher {
  constructor(private readonly dispatch: Dispatch) {
  }

  public startGlobalLoading() {
    this.dispatch(startLoadingAction());
  }

  public endGlobalLoading() {
    this.dispatch(endLoadingAction());
  }

  public toggleSpMenu() {
    this.dispatch(toggleSpMenuAction());
  }
}

export default GlobalDispatcher;
